import { makeStyles } from "@material-ui/core";
export const offerSlideStyles = makeStyles((theme) => ({
    paper:{
        display:"flex", 
        alignItems:"center", 
        justifyCenter:"center", 
        minHeight:"450px", 
        boxShadow:"none"
    }
}))